import React from 'react'
import { Box } from '@chatterbug/aaron'

import CurrentUnitIndicator, {
  INDICATOR_SHAPE_POSITION_STYLES,
} from '../UnitListItem/subcomponents/CurrentUnitIndicator/CurrentUnitIndicator'

const DROP_PLACEHOLDER_BG = 'gray88'

const DROP_PLACEHOLDER_STYLES = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: 104,
  borderRadius: '1x',
  backgroundColor: DROP_PLACEHOLDER_BG,
}

const UnitListItemDropPlaceholder = () => (
  <Box sx={DROP_PLACEHOLDER_STYLES}>
    <CurrentUnitIndicator
      sx={{
        ...INDICATOR_SHAPE_POSITION_STYLES,
        backgroundColor: DROP_PLACEHOLDER_BG,
        color: DROP_PLACEHOLDER_BG,
        zIndex: 'auto',
      }}
    />
  </Box>
)

export default UnitListItemDropPlaceholder
